import {Injectable} from '@angular/core';
import {Tax} from '../models/account/tax';


@Injectable({
  providedIn: 'root'
})
export class TaxService {

  constructor() {
  }

  /**
   * Compute taxes.
   * @param tax Tax.
   * @param amount  number.
   * @param quantity  number.
   */
  computeTaxes(tax: Tax, amount: number, quantity: number) {
    if (tax.accountType.toLowerCase() === 'fixed') {
      return this.copySign(tax.amount, amount) * quantity;
    }
    if ((tax.accountType.toLowerCase() === 'percent' && !tax.priceIncluded) || (tax.accountType.toLowerCase() === 'division' && tax.priceIncluded)) {
      return amount * (tax.amount / 100);
    }
    if (tax.accountType.toLowerCase() === 'percent' && tax.priceIncluded) {
      return (amount * (1 + (tax.amount / 100))) - amount;
    }
    if (tax.accountType.toLowerCase() === 'division' && !tax.priceIncluded) {
      return (amount / (1 - tax.amount / 100)) - amount;
    }
  }

  /**
   * Copy sign of the second parameter.
   *
   * @param a number.
   * @param b number.
   * @return number.
   */
  copySign(a: number, b: number) {
    if (b < 0) {
      if (a < 0) {
        return a;
      } else {
        return -1 * a;
      }
    } else {
      return Math.abs(a);
    }
  }
}
